import { Hint as e } from "./hint.mjs";
import { useEditorState as t } from "@tiptap/react";
import { twMerge as n } from "tailwind-merge";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/character-count.tsx
function i({ hint: i, editor: a, className: o }) {
	let s = t({
		editor: a,
		selector: ({ editor: e }) => ({ count: e?.storage.characterCount.characters() })
	});
	if (!a) return null;
	let c = s?.count || "";
	return c ? /* @__PURE__ */ r(e, {
		label: i ?? "",
		showHint: !!i,
		className: n(o, "h-5"),
		children: /* @__PURE__ */ r("span", {
			className: "mt-[2px]",
			children: c
		})
	}) : /* @__PURE__ */ r("div", { className: n(o, "h-5") });
}
//#endregion
export { i as CharacterCount };
